/* ODVARO - lista ulubionych. Bez logowania, bez backendu. Dane w localStorage przegladarki. */
(function () {
  'use strict';

  var KEY = 'odvaro_wishlist_v1';
  var EVENT = 'odvaro:wishlist:changed';
  var WL_URL = '/pages/ulubione';

  var HEART_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.7l-1.4-1.3C5.4 14.7 2 11.6 2 7.9 2 5.1 4.2 3 7 3c1.6 0 3.1.7 4 1.9C11.9 3.7 13.4 3 15 3c2.8 0 5 2.1 5 4.9 0 3.7-3.4 6.8-8.6 11.5L12 20.7z"/>' +
    '</svg>';

  var storageAvailable = (function () {
    try {
      var probe = '__odvaro_probe__';
      window.localStorage.setItem(probe, '1');
      window.localStorage.removeItem(probe);
      return true;
    } catch (e) {
      return false;
    }
  })();

  /* In-memory cache = zrodlo prawdy w trakcie sesji. localStorage czytamy raz
     przy starcie, a przy kliknieciu tylko zapisujemy - odroczenie poza klatke. */
  var cache = null;

  function readStorage() {
    if (!storageAvailable) return [];
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (h) {
        return typeof h === 'string' && h.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function read() {
    if (cache === null) cache = readStorage();
    return cache;
  }

  var persistScheduled = false;

  function persist() {
    if (!storageAvailable) return;
    try {
      window.localStorage.setItem(KEY, JSON.stringify(cache));
    } catch (e) {}
  }

  /* Zapis do localStorage jest synchroniczny i blokuje watek - odkladamy go
     na bezczynnosc przegladarki, zeby nie liczyl sie do INP klikniecia. */
  function schedulePersist() {
    if (persistScheduled) return;
    persistScheduled = true;
    var run = function () {
      persistScheduled = false;
      persist();
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 2000 });
    } else {
      window.setTimeout(run, 0);
    }
  }

  function write(list) {
    cache = list;
    schedulePersist();
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { list: list } }));
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read().slice();
    var i = list.indexOf(handle);
    var added = i === -1;
    if (added) list.push(handle);
    else list.splice(i, 1);
    write(list);
    return added;
  }

  function remove(handle) {
    var list = read().slice();
    var i = list.indexOf(handle);
    if (i !== -1) {
      list.splice(i, 1);
      write(list);
    }
  }

  function handleFromUrl(url) {
    if (!url) return null;
    var match = String(url).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function buildButton(handle, title, variant) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'odvaro-wl-btn odvaro-wl-btn--' + (variant || 'card');
    btn.setAttribute('data-wishlist-toggle', '');
    btn.setAttribute('data-wishlist-handle', handle);
    btn.setAttribute('data-wishlist-title', title || 'produkt');
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = HEART_SVG + '<span class="odvaro-wl-btn__label"></span>';
    return btn;
  }

  function injectHeaderIcon() {
    var iconBars = document.querySelectorAll('.header__icons');

    iconBars.forEach(function (bar) {
      if (bar.querySelector('.odvaro-wl-header')) return;

      var cart = bar.querySelector('#cart-icon-bubble') || bar.querySelector('.header__icon--cart');
      if (!cart) return;

      var link = document.createElement('a');
      link.href = WL_URL;
      link.className = 'header__icon header__icon--wishlist link focus-inset odvaro-wl-header';
      link.innerHTML =
        HEART_SVG +
        '<span class="visually-hidden">Ulubione</span>' +
        '<span class="odvaro-wl-count" aria-hidden="true"></span>';

      cart.parentNode.insertBefore(link, cart);
    });
  }

  /* Serduszko trafia do .card-wrapper, a NIE do .card__inner. */
  function injectIntoCards(scope) {
    var root = scope || document;
    var cards = root.querySelectorAll('.card-wrapper.product-card-wrapper');

    cards.forEach(function (card) {
      if (card.querySelector('[data-wishlist-toggle]')) return;

      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      var handle = handleFromUrl(link.getAttribute('href'));
      if (!handle) return;

      var title = (link.textContent || '').trim() || 'produkt';
      card.appendChild(buildButton(handle, title, 'card'));
    });
  }

  /* Serduszko OBOK przycisku 'Dodaj do koszyka', w jednym rzedzie.
     Owijamy .product-form__buttons klasa, ktora robi z niego flex-row,
     i wstawiamy kwadratowe serduszko jako drugi element. */
  function injectIntoProductPage() {
    if (document.querySelector('.odvaro-wl-btn--product-inline')) return;

    var handle = handleFromUrl(window.location.pathname);
    if (!handle) return;

    var buttons = document.querySelector('.product-form__buttons');
    if (!buttons) return;

    var heading = document.querySelector('.product__title h1, .product__title, h1');
    var title = heading ? (heading.textContent || '').trim() : 'produkt';

    buttons.classList.add('odvaro-wl-buttons-row');
    buttons.appendChild(buildButton(handle, title, 'product-inline'));
  }

  function syncButton(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;

    var active = has(handle);
    var title = btn.getAttribute('data-wishlist-title') || 'produkt';

    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute(
      'aria-label',
      active ? 'Usun ' + title + ' z ulubionych' : 'Dodaj ' + title + ' do ulubionych'
    );

    var label = btn.querySelector('.odvaro-wl-btn__label');
    if (label) label.textContent = active ? 'W ulubionych' : 'Dodaj do ulubionych';
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
  }

  function syncCounters() {
    var count = read().length;
    document.querySelectorAll('.odvaro-wl-count').forEach(function (el) {
      el.textContent = String(count);
      el.classList.toggle('is-visible', count > 0);
    });
    document.querySelectorAll('.odvaro-wl-header').forEach(function (el) {
      el.classList.toggle('has-items', count > 0);
      el.setAttribute('aria-label', count > 0 ? 'Ulubione (' + count + ')' : 'Ulubione');
    });
  }

  function injectMenuCounters() {
    var links = document.querySelectorAll(
      'a[href$="/pages/ulubione"]:not(.odvaro-wl-header), a[href*="/pages/ulubione?"]:not(.odvaro-wl-header)'
    );
    links.forEach(function (link) {
      if (link.querySelector('.odvaro-wl-count')) return;
      var badge = document.createElement('span');
      badge.className = 'odvaro-wl-count';
      badge.setAttribute('aria-hidden', 'true');
      link.appendChild(badge);
    });
  }

  function refresh(scope) {
    injectHeaderIcon();
    injectIntoCards(scope);
    injectIntoProductPage();
    injectMenuCounters();
    syncAllButtons();
    syncCounters();
  }

  /* Ciezki sync wszystkich serc + licznikow przenosimy do rAF, zeby nie
     wykonywal sie w krytycznej klatce klikniecia (processing time INP). */
  var syncScheduled = false;

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    window.requestAnimationFrame(function () {
      syncScheduled = false;
      syncAllButtons();
      syncCounters();
    });
  }

  /* Faza przechwytywania - lapiemy klik zanim dotrze do linku karty. */
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('[data-wishlist-toggle]');
      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();

      var handle = btn.getAttribute('data-wishlist-handle');
      if (!handle) return;

      toggle(handle);

      /* Natychmiastowy feedback tylko na klknietym sercu; reszta w rAF. */
      syncButton(btn);

      btn.classList.remove('is-animating');
      void btn.offsetWidth;
      btn.classList.add('is-animating');
    },
    true
  );

  document.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('[data-wishlist-remove]');
    if (!removeBtn) return;
    event.preventDefault();
    remove(removeBtn.getAttribute('data-wishlist-remove'));
    var page = document.querySelector('[data-wishlist-page]');
    if (page) renderPage(page);
  });

  document.addEventListener(EVENT, scheduleSync);

  window.addEventListener('storage', function (event) {
    if (event.key !== KEY) return;
    cache = readStorage();
    scheduleSync();
    var page = document.querySelector('[data-wishlist-page]');
    if (page) renderPage(page);
  });

  function formatMoney(cents) {
    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';
    try {
      return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: currency }).format(
        cents / 100
      );
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function sizedImage(url, width) {
    if (!url) return '';
    var joiner = url.indexOf('?') === -1 ? '?' : '&';
    return url + joiner + 'width=' + width;
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function emptyMarkup() {
    return (
      '<div class="odvaro-wl-empty">' +
      '<div class="odvaro-wl-empty__heart" aria-hidden="true">&#9825;</div>' +
      '<p>Tu pojawią się Twoje ulubione zapachy.<br>Wystarczy kliknąć serduszko przy produkcie.</p>' +
      '<a href="/collections/all" class="button">Przeglądaj zapachy</a>' +
      '</div>'
    );
  }

  function cardMarkup(product) {
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var safeTitle = escapeHtml(product.title);
    var priceLine = product.available
      ? '<div class="odvaro-wl-card__price">od ' + formatMoney(product.price) + '</div>'
      : '<div class="odvaro-wl-card__sold-out">Chwilowo niedostępne</div>';

    return (
      '<li class="odvaro-wl-card">' +
      '<button type="button" class="odvaro-wl-card__remove" data-wishlist-remove="' +
      escapeHtml(product.handle) +
      '" aria-label="Usuń ' +
      safeTitle +
      ' z ulubionych">&times;</button>' +
      '<a href="/products/' +
      encodeURIComponent(product.handle) +
      '" class="odvaro-wl-card__media">' +
      (image
        ? '<img src="' +
          sizedImage(image, 400) +
          '" alt="' +
          safeTitle +
          '" width="400" height="400" loading="lazy">'
        : '') +
      '</a>' +
      '<a href="/products/' +
      encodeURIComponent(product.handle) +
      '" class="odvaro-wl-card__title">' +
      safeTitle +
      '</a>' +
      priceLine +
      '</li>'
    );
  }

  function renderPage(root) {
    if (!storageAvailable) {
      root.innerHTML =
        '<div class="odvaro-wl-empty"><p>Ta przeglądarka blokuje zapisywanie danych, więc lista ulubionych nie zadziała. Warto sprawdzić ustawienia prywatności lub wyłączyć tryb prywatny.</p></div>';
      return;
    }

    var handles = read();
    if (!handles.length) {
      root.innerHTML = emptyMarkup();
      return;
    }

    root.innerHTML = '<div class="odvaro-wl-loading">Wczytuję ulubione...</div>';

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var alive = [];
      var cards = [];

      products.forEach(function (product, index) {
        if (!product) return;
        alive.push(handles[index]);
        cards.push(cardMarkup(product));
      });

      if (alive.length !== handles.length) write(alive);

      root.innerHTML = cards.length
        ? '<ul class="odvaro-wl-grid">' + cards.join('') + '</ul>'
        : emptyMarkup();
    });
  }

  function init() {
    if (!storageAvailable) {
      document.documentElement.classList.add('odvaro-wl-unavailable');
      var blocked = document.querySelector('[data-wishlist-page]');
      if (blocked) renderPage(blocked);
      return;
    }

    refresh();

    var page = document.querySelector('[data-wishlist-page]');
    if (page) renderPage(page);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    refresh();
  });

  /* Obserwujemy tylko tresc strony (nie caly dokument) i tylko dodane karty
     produktow. Widgety opinii/aplikacji nie wyzwalaja juz przeliczen.
     Odswiezenie odkladamy na bezczynnosc przegladarki (INP). */
  if (window.MutationObserver) {
    var pending = false;
    var later = function (fn) {
      if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 500 });
      else window.requestAnimationFrame(fn);
    };
    var isCardNode = function (node) {
      if (node.nodeType !== 1) return false;
      if (node.classList.contains('product-card-wrapper')) return true;
      return !!(node.firstElementChild && node.querySelector('.card-wrapper.product-card-wrapper'));
    };
    var observer = new MutationObserver(function (mutations) {
      if (pending) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (isCardNode(added[j])) {
            pending = true;
            later(function () {
              pending = false;
              refresh();
            });
            return;
          }
        }
      }
    });
    var target = document.getElementById('MainContent') || document.body;
    observer.observe(target, { childList: true, subtree: true });
  }

  window.OdvaroWishlist = {
    get: read,
    has: has,
    toggle: toggle,
    remove: remove,
    count: function () {
      return read().length;
    },
    refresh: refresh,
  };
})();